import React from 'react';
import { FieldValues, Path } from 'react-hook-form';
import { useSelectableCountries } from '~/App/shared/hooks/useSelectableCountries';
import SelectWithControl from '~/App/shared/components/Fields/SelectWithControl';
import { SelectProps } from '../types';

interface CountryFieldProps<
  FormState extends FieldValues
> extends SelectProps<FormState> {
  disableSweden?: boolean;
}

const CountryField = <FormState extends FieldValues>({
  control,
  t,
  name,
  rules,
  disableSweden,
  ...props
}: CountryFieldProps<FormState>) => {
  const validationRules = {
    required: {
      value: true,
      message: t(`Country can't be blank`)
    },
    validate: (value: { label: string; value: string }) => {
      return value.value !== '' || t(`Country can't be blank`);
    },
    ...rules
  };

  const fieldName = name ?? ('country' as Path<FormState>);
  const countrySelectProps = useSelectableCountries(Boolean(props.isDisabled));

  return (
    <SelectWithControl
      {...props}
      control={control}
      name={fieldName}
      label={t('Country')}
      {...countrySelectProps}
      helperText={countrySelectProps.helperText ?? props.helperText}
      rules={validationRules}
      isOptionDisabled={option =>
        Boolean(disableSweden) && option.value === 'se'
      }
      required
    />
  );
};

export default CountryField;
